import http from 'plugins/axios';

export default {
  getList(data) {
    return http.get({
      url: '/admin/ballot/list',
      data
    });
  },
  create(data) {
    return http.post({
      url: '/admin/ballot/create',
      data,
      dataType: 'form'
    });
  },
  update(data) {
    return http.post({
      url: '/admin/ballot/create',
      data,
      dataType: 'form'
    });
  },
  updateEnabled(data) {
    return http.post({
      url: '/admin/ballot/update/enabled',
      data,
      dataType: 'form'
    });
  },
  setAvailableVotes(data){
    console.log("传递数据"+data);
    return http.post({
      url:'/admin/voteBatch/total_vote_set',
      data,
      dataType:'form'
    })
  }
};
